import { Charge } from 'lane-shared/domains/billingPayments/types';

import {
  canRetry,
  VerifyAndSubmitFailure,
} from '../../verifyAndSubmit/verifyAndSubmitFailure';

type Input = {
  charges: Charge[];
  itemCount: number;
  canVerifyAndSubmit: boolean;
  isServiceRequestComplete: boolean;
  hasResolvedIds: boolean;
  isSubmitting: boolean;
  validation?: string;
  failure?: VerifyAndSubmitFailure;
};

const FAILURE_MESSAGE_KEYS: Record<VerifyAndSubmitFailure['kind'], string> = {
  'verification-failed': 'abp.charges.verifyAndSubmit.error.verificationFailed',
  'not-yet-visible': 'abp.charges.verifyAndSubmit.error.notYetVisible',
  'attempts-exhausted': 'abp.charges.verifyAndSubmit.error.attemptsExhausted',
  'not-verifiable': 'abp.charges.verifyAndSubmit.error.notVerifiable',
  'service-request-not-complete':
    'abp.charges.verifyAndSubmit.error.serviceRequestNotComplete',
  generic: 'abp.charges.chargeManager.draftCharge.createChargeError',
};

export function createVerifyAndSubmitViewModel({
  charges,
  itemCount,
  canVerifyAndSubmit,
  isServiceRequestComplete,
  hasResolvedIds,
  isSubmitting,
  validation,
  failure,
}: Input) {
  const hasNonVoidedCharge = charges.some(charge => charge.status !== 'VOIDED');
  const hasSubmittedCharge = Boolean(failure?.chargeId);
  const canAct = canVerifyAndSubmit && hasResolvedIds && !isSubmitting;
  const showVerifyButton = itemCount > 0 && !hasSubmittedCharge;

  return {
    showEditor: !hasNonVoidedCharge,
    isEditorReadOnly: hasSubmittedCharge,
    showVerifyButton,
    isVerifyDisabled:
      !canAct || !isServiceRequestComplete || Boolean(validation),
    showIncompleteServiceRequestHint:
      showVerifyButton && !isServiceRequestComplete,
    showRetryButton: failure?.chargeId !== undefined && canRetry(failure),
    isRetryDisabled: !canAct,
    failureMessage: failure && {
      key: FAILURE_MESSAGE_KEYS[failure.kind],
      chargeId: failure.chargeId,
    },
  };
}
